module.exports = __webpack_public_path__ + "images/affiliate-marketing.png";